import React from "react";
import styled from "@emotion/styled";
import { Box, Text } from "@atoms";

// == Types ================================================================

interface IProps {
  orgName: string;
  orgAddress: string;
  orgCity: string;
  orgCountry: string;
  orgPostalCode: string;
  orgProvince: string;
  orgWebsite: string;
}

// == Constants ============================================================

BeneficiaryOrgPreview.defaultProps = {};

// == Component ============================================================

export default function BeneficiaryOrgPreview({
  orgName,
  orgAddress,
  orgCity,
  orgCountry,
  orgPostalCode,
  orgProvince,
  orgWebsite,
}: IProps) {
  return (
    <Box mb={4}>
      {orgName && (
        <Text as="span" display="block">
          {orgName}
        </Text>
      )}
      {orgAddress && (
        <Text as="span" display="block">
          {orgAddress}
        </Text>
      )}
      {orgCity && (
        <Text as="span" display="block">
          {orgCity}, {orgProvince}, {orgCountry}
        </Text>
      )}
      {orgPostalCode && (
        <Text as="span" display="block">
          {orgPostalCode}
        </Text>
      )}
      {orgWebsite && (
        <EText fontSize={1} as="span" display="block">
          {orgWebsite}
        </EText>
      )}
    </Box>
  );
}

// == Styles ===============================================================

const EText = styled(Text)`
  word-break: break-all;
`;
